import { Loader2 } from "lucide-react";

export default function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  confirming = false,
  title = "Are you sure?",
  description = "",
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  danger = false,
}) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/50"
      onClick={() => !confirming && onClose?.()}
      data-testid="confirm-dialog"
    >
      <div
        className="bg-white rounded-2xl w-full max-w-sm shadow-xl border border-slate-200 p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="text-base font-semibold text-slate-900">{title}</h3>
        {description && (
          <p className="mt-2 text-sm text-slate-600">{description}</p>
        )}
        <div className="flex justify-end gap-2 mt-5">
          <button
            type="button"
            onClick={() => !confirming && onClose?.()}
            disabled={confirming}
            className="px-4 py-2 rounded-lg text-slate-700 border border-slate-200 hover:bg-slate-50 transition"
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={confirming}
            data-testid="confirm-dialog-confirm"
            className={`inline-flex items-center gap-2 px-4 py-2 rounded-lg text-white font-semibold transition disabled:opacity-70 ${
              danger
                ? "bg-red-600 hover:bg-red-700"
                : "bg-slate-900 hover:bg-slate-800"
            }`}
          >
            {confirming && <Loader2 className="animate-spin" size={14} />}
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
